import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';
import { log } from '@/utils/functions/logger/logger';

export type SendLogEvent = (event: string, data?: { [key: string]: unknown }) => Promise<void>;

export const sendLogEvent: SendLogEvent = async (event, data) => {
  try {
    void TRACKING_INSTANCE.triggerEvent(event, undefined, data);
  } catch (error) {
    log.error(`sendLogEvent failed: ${error}`);
  }
};
